import { extendTheme } from "@chakra-ui/react";
import { createButtonStyles } from "styles/components/buttonStyles";

export function buildTheme(primaryColor: string, secondaryColor: string) {
  return extendTheme({
    fonts: {
      heading: "DM Sans",
      body: "DM Sans",
    },
    colors: {
      primary: primaryColor,
      brand: {
        secondary: secondaryColor,
      },
      blue: {
        500: primaryColor,
      },
      secondary: {
        100: "#E7ECFD",
        400: "#4D4D4D",
      },
      critical: {
        100: "#C71313",
      },
      header: {
        top__bg: "#0A0C29",
        bottom__bg: "#E7ECFD",
      },
    },
    components: {
      Button: createButtonStyles(primaryColor),
    },
  });
}

export default buildTheme;
